import SubStep1 from './step-1/subStep1';
import SubStep2 from './step-1/subStep2';
import Step2 from './step-2/step2';
import Step_3 from './step-3/step3';
import Step_41 from './step-4/step41';
import Step42 from './step-4/step42';
import Landing from './step-4/landing';
import ForwardModal from './step-2/forwardModal';
export {
  SubStep1,
  SubStep2,
  Step2,
  Step_3,
  Landing,
  Step_41,
  Step42,
  ForwardModal,
};